<template>
    <div class="maincontent">
        <section class="section has-background-light">
            <br><br><br>
            <div class="container box apropos my-1">
                <h1 class="maintitlex is-size-3 has-text-weight-medium pb-4">Le journal Paroissial</h1>
                <p>Fondé en 1947 par le Père André Goubely, dans un but pastoral et missionnaire, il a pris une dimension nationale avec actuellement 80 journaux paroissiaux.</p>
                <br>
                <p>Organe de publication de l’association du même nom, il propose tous les mois à ses adhérents un fonds commun « Le Journal Paroissial » de 24 pages, en quadrichromie, qui permet aux comités de rédaction paroissiaux d’éditer leur propre journal avec une partie d’articles généraux et une partie d’articles propres.</p>
                <p>Une trentaine de rédacteurs contribue à cette publication. Au fil des ans, le Journal Paroissial a toujours fait face aux mutations du monde moderne et s’est adapté à la technique.</p>
                <br>
                <div class="columns">
                    <div class="column is-one-third">
                        <img alt="arbre" src="../assets/arbre.jpg" width="320" height="320">
                    </div>
                    <div class="column">
                        <h2 class="subtitle has-text-info"><b>NOS FORCES</b></h2>
                        <ul>
                            <li>Des rédacteurs expérimentés avec des centres d’intérêt divers, religieux et profanes.</li>
                            <li>Une liberté d’édition pour chaque bulletin paroissial (rythme, nombre de pages, choix des articles…).</li>
                            <li>Une aide auprès des équipes de rédaction sur appel de leur part.</li>
                            <li>La mise en pages par le service PAO de l’imprimerie de leurs textes propres (illustrations…).</li>
                        </ul>
                        <br>
                        <h2 class="subtitle has-text-info"><b>NOS OBJECTIFS</b></h2>
                        <ul>
                            <li>Nourrir les chrétiens (Bible, questions d’Eglise et d’actualité…).</li>
                            <li>Etre proche des préoccupations des « hommes de ce temps ».</li>
                            <li>Rendre visible la vie de la communauté locale du doyenné, du diocèse.</li>
                            <li>Rendre visible le message de l’Evangile.</li>
                        </ul>
                        <p><br>Belle et folle aventure pour annoncer la Bonne Nouvelle, aujourd’hui comme hier.</p>
                    </div>
                </div>
                <br>
            </div>
        </section>

        <LastEdition />

        <section class="section has-background-white">
            <div class="container">
                <h3 class="title">Achat et abonnement</h3>
                <div align="center"><img alt="abonnement" src="../assets/mailbox.png" width="160" height="160"></div>
                <div class="columns  has-text-centered">
                    <div class="column">
                        <h2 class="subtitle is-4">S'abonner au journal</h2>
                        Vous pouvez vous abonner à l'édition papier pour 1 an / 10 n°.
                        <br>Abonnez-vous maintenant et recevez dès le mois prochain votre 1er numéro!
                        <div class="has-text-centered"><br>
                            <router-link class="button is-warning is-medium is-rounded my-3" to="/page/achat-et-abonnement">S'abonner</router-link>
                        </div>
                    </div>
                    <div class="column">
                        <h2 class="subtitle is-4">Acheter le journal</h2>
                        Vous pouvez acheter des N° de notre journal à l'unité.<br>Il est possible de n'acheter, en version numérique, que certains chapitres.
                        <div class="has-text-centered"><br>
                            <router-link class="button is-warning is-medium is-rounded my-3" to="/parutions">Voir la Boutique</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <br><br>
        <section class="section has-background-light" id="contactsection">
            <div class="container boxv">
                <h3 class="title" id="contact">Nous contacter</h3>
                <br>
                <div v-if="infoscontact" class="boxv">
                    <div class="columns">
                        <div class="column">
                            <h2 class="subtitle is-4">Téléphone</h2>
                            <span>&phone;
                                <a href="tel:infoscontact.telephone">{{infoscontact.telephone}}</a><br>{{infoscontact.horaires}}</span>
                        </div>
                        <div class="column">
                            <h2 class="subtitle is-4">Email</h2>
                            <span><a :href="'mailto:' + infoscontact.email">{{infoscontact.email}}</a>
                            </span>
                        </div>
                        <div class="column">
                            <h2 class="subtitle is-4">Courrier</h2>
                            <span class="nl2br">{{infoscontact.adresse}}</span>
                        </div>
                    </div>
                    <br><br>
                    <div align="center"><img alt="contact" src="../assets/contact.svg" width="400" height="300"></div>
                </div>
            </div>
            <br><br>
        </section>
    </div>
</template>
<script>
import 'aos/dist/aos.css';
import AOS from 'aos';
import LastEdition from '../components/LastEdition.vue'

AOS.init()
const axios = require('axios');

export default {
    name: 'Landing',
    data: function() {
        return {
            maintitle: 'Accueil JP | Welcome!',
            loading: true,
            error: null,
            infoscontact: null
        }
    },
    components: {
        LastEdition,
    },
    created() {
        this.getInfosContact()
    },
    methods: {
        totop: function() {
            window.scrollTo(0, 0);
        },
        getInfosContact: function() {
            this.error = this.infoscontact = null
            this.loading = true
            var vm = this
            var fetchurl = this.$api_url_infoscontact
            axios({
                    method: 'post',
                    url: fetchurl,
                    headers: { 'Content-Type': 'application/json' },
                }).then(function(response) {
                    vm.infoscontact = response.data
                    //console.log(response.data)
                })
                .catch(function() {
                })
        },
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page {
    min-height: 300px;
    margin-bottom: 40px;
}

#totop:hover {
    cursor: pointer;
}

.headsup {
    padding: 20px 20px;

    color: #fff;
    font-size: 14pt;
}

.headsup a {
    color: #fff;
    border-bottom: 1px dashed white;
}

.hu_adh {
    background: #39ae76;
}

.hu_news {
    background: #8aa8bd;
}

.hu_news img {
    margin-left: auto;
    margin-right: auto;
}

.apropos {
    -webkit-box-shadow: 0px 0px 9px -1px #ddd;
    -moz-box-shadow: 0px 0px 9px -1px #ddd;
    box-shadow: 0px 0px 9px -1px #ddd;
}

.nl2br {
    white-space: pre;
}


@media only screen and (max-width: 415px) {
    .maincontent {
        padding-left: 10px;
        padding-right: 10px;
    }

}
</style>